export default __webpack_public_path__ + "static/image-8-dbd7941a61ff31596a6b424ad2a18708.jpg";